import React, {useEffect, useState, useRef, useCallback} from 'react';
import {Animated} from 'react-native';
import {useNavigation} from '@react-navigation/native';
import {api, apiv2} from '../../../services/api';

import { RFValue} from 'react-native-responsive-fontsize';
import {ScrollView} from 'react-native-gesture-handler';
import {useTheme} from 'styled-components/native';
import {Header as HeaderButton} from '../../../components/Interface/Headers/Header';
import thumbVideo from '../../../assets/images/banners/thumb-checkin.webp';

import {
  Container,
  Content,
  CheckinContainer,

  TopContent,
  Title,
  InfoTitle,
  Balance,
  BaratinhasContainer,
  BalanceContainer,
  InfoItem,
  InfoItemContent,
  InfoItemTitle,
  InfoDescription,

  Footer,
  ContentWrapper,
  HelpVideoContainer,
  HelpVideoThumb,

  HelpVideoThumbContent,
  HelpVideoThumbHeader,
} from './styles';

import CheckinComponent from '../../../components/shared/Checkin';
import {
  CheckinResponse,
  CheckinStatus,
} from '../../../components/shared/Checkin/types';
import {Button} from '../../../components/Interface/Forms/Buttons/Button';
import {Maintenance} from '../../../components/Interface/Maintenance';
import {Icon} from '../../../components/Interface/Typographies/Icon';
import {Titles} from '../../../components/Interface/Typographies/Titles';
import {Loading} from '../../../components/Interface/Loadings/Loading';
import {Baratinhaz} from '../../../components/Interface/Baratinhaz';
import { HelpVideo } from '../../../components/shared/HelpVideo';
import { useAuth } from '../../../context/auth';
import { useGlobal } from '../../../context/global';

export function Checkin(): JSX.Element {
  const navigation = useNavigation();
  const theme = useTheme();
  const {isLogged} = useAuth();
  const {disabledFeatures} = useGlobal();
  const isDisabled = (key: string) => disabledFeatures.includes(key);

  const [baratinhas, setBaratinhas] = useState<number>(0);
  const [displayPoints, setDisplayPoints] = useState<number>(0);
  const [checkinStatus, setCheckinStatus] = useState<CheckinStatus>();
  const [isLoadingBaratinhas, setIsLoadingBaratinhas] = useState<boolean>(true);
  const [isLoadingCheckin, setIsLoadingCheckin] = useState<boolean>(true);
  const [errorCheckin, setErrorCheckin] = useState<boolean>(false);
  const [showVideo, setShowVideo] = useState(false);

  const lottieScale = useRef(new Animated.Value(1)).current;
  const [, setLottieSpeed] = useState<number>(1);

   useEffect(() => {
      if(!isLogged){
        navigation.navigate('Home');
      }
    }, [isLogged]);

  useEffect(() => {
    setDisplayPoints(baratinhas);
  }, [baratinhas]);

  const buscaBaratinhas = useCallback(async () => {
    setIsLoadingBaratinhas(true);
    try {
      const resp = await api.get<number>('/consultaBaratinhas');
      setBaratinhas(resp.data);
    } finally {
      setIsLoadingBaratinhas(false);
    }
  }, []);

  const fetchInitial = useCallback(async () => {
    setIsLoadingCheckin(true);
    try {
      const resp = await apiv2.get<CheckinStatus>('/status_checkin');
      setCheckinStatus(resp.data);
      setErrorCheckin(false);
    } catch {
      setErrorCheckin(true);
    } finally {
      setIsLoadingCheckin(false);
    }
  }, []);

  // aqui corrigimos para bounce de 0.5s fluido, termina quando a contagem acabar
  const animateCoins = useCallback(
    (pointsToAdd: number) => {
      if (pointsToAdd <= 0) {return;}
      const start = baratinhas;
      const totalDuration = 1500; // duração total da contagem em ms
      const countInterval = totalDuration / pointsToAdd;

      setLottieSpeed(1.3);

      // bounce de 0.5s: 250ms up, 250ms down
      const bounceSeq = Animated.sequence([
        Animated.timing(lottieScale, {
          toValue: 1.5,
          duration: 250,
          useNativeDriver: true,
        }),
        Animated.timing(lottieScale, {
          toValue: 1,
          duration: 250,
          useNativeDriver: true,
        }),
      ]);
      const bounceLoop = Animated.loop(bounceSeq);
      bounceLoop.start();

      let count = 0;
      const timer = setInterval(() => {
        count += 1;
        setDisplayPoints(start + count);

        if (count === pointsToAdd) {
          clearInterval(timer);
          bounceLoop.stop();
          setTimeout(() => {
            setBaratinhas(start + pointsToAdd);
            setLottieSpeed(1);
          }, 0);
        }
      }, countInterval);
    },
    [baratinhas, lottieScale],
  );

  const handleCheckin = useCallback(
    async (checkin?: CheckinResponse) => {
      try {
        const resp = await apiv2.get<CheckinStatus>('/status_checkin');
        setCheckinStatus(resp.data);
        setErrorCheckin(false);
        animateCoins(checkin?.qtd_pontos ?? 0);
      } catch {
        setErrorCheckin(true);
      } finally {
        buscaBaratinhas();
      }
    },
    [animateCoins],
  );

  useEffect(() => {
    fetchInitial();
    buscaBaratinhas();
  }, [fetchInitial, buscaBaratinhas]);

  if (isDisabled('checkin')) {
    return <Maintenance />;
  }

  if (isLoadingBaratinhas || isLoadingCheckin) {
    return <Loading />;
  }

  return (
    <Container
      style={{
        backgroundColor: errorCheckin
          ? theme.colors.background
          : theme.colors.primary,
      }}>
      {errorCheckin ? (
        <Maintenance />
      ) : (
        <ScrollView
          contentContainerStyle={{
            paddingBottom: RFValue(20),


          }}
          showsVerticalScrollIndicator={false}
          bounces={false}
          overScrollMode="never">
          <HelpVideoContainer
            onPress={() => setShowVideo(true)}
            activeOpacity={1}>
            <HelpVideoThumb source={thumbVideo}>
              <HelpVideoThumbHeader>
              <HeaderButton
                icon="chevron-left"
                statusBarLight
                color={theme.colors.shape}
              />
              </HelpVideoThumbHeader>

             <HelpVideoThumbContent>
               <Title>Check-in diário</Title>
             </HelpVideoThumbContent>
            </HelpVideoThumb>


          </HelpVideoContainer>
          <TopContent
            colors={['#009d88', theme.colors.primary]}
            start={{x: 0, y: 1}}
            end={{x: 0, y: 0}}>

            <CheckinContainer>
              {!!checkinStatus && (
                <CheckinComponent
                  data={checkinStatus}
                  onCheckin={handleCheckin}
                />
              )}
            </CheckinContainer>

            <BaratinhasContainer>
              <InfoTitle color={theme.colors.shape}>Suas baratinhaZ:</InfoTitle>
              <BalanceContainer>
                <Baratinhaz />
                <Balance>
                  {isLoadingBaratinhas ? '••••' : displayPoints} btz
                </Balance>
              </BalanceContainer>
            </BaratinhasContainer>
          </TopContent>

          <Content>
            <ContentWrapper>
              <Titles
                title="Sobre o Check-in"
                subtitle="Saiba como funciona e receba suas baratinhaZ!"
              />
              <InfoItem>
                <Icon name="calendar-day" awesome5 />
                <InfoItemContent>
                  <InfoItemTitle>Recompensa diária</InfoItemTitle>
                  <InfoDescription>
                    A cada check-in você recebe uma recompensa do dia
                  </InfoDescription>
                </InfoItemContent>
              </InfoItem>
              <InfoItem>
                <Icon name="calendar-week" awesome5 />
                <InfoItemContent>
                  <InfoItemTitle>Recompensa semanal</InfoItemTitle>
                  <InfoDescription>
                    A cada semana que você completar, receberá as baratinhaZ da
                    semana em destaque.
                  </InfoDescription>
                </InfoItemContent>
              </InfoItem>
              <InfoItem>
                <Icon name="calendar-alt" awesome5 />
                <InfoItemContent>
                  <InfoItemTitle>Recompensa total</InfoItemTitle>
                  <InfoDescription>
                    Ao completar 4 semanas, você receberá o prêmio final!
                  </InfoDescription>
                </InfoItemContent>
              </InfoItem>
            </ContentWrapper>
            <Footer>
              <Button
                title="Preciso de ajuda"
                enabled
                onPress={() => navigation.navigate('Help')}
              />
            </Footer>
          </Content>
        </ScrollView>
      )}

      {showVideo && <HelpVideo videoURI="https://d3ag5cip9ldvh3.cloudfront.net/CHECKIN.MP4" onVideoEnd={() => setShowVideo(false)}/>}
    </Container>
  );
}
